import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classnames from 'classnames';
const Table = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className, bordered, condensed, striped, hover, borderless, variant, responsive, children, ...rest } = props;
    const bsClass = classnames('table', className, {
        'table-bordered': !!bordered
    }, {
        'table-sm': !!condensed
    }, {
        'table-striped': !!striped
    }, {
        'table-hover': !!hover
    }, {
        'table-borderless': !!borderless
    }, {
        [`table-${variant}`]: !!variant
    });
    const table = /*#__PURE__*/ _jsx("table", {
        ...rest,
        ref: ref,
        className: bsClass,
        children: children
    });
    if (responsive) {
        let responsiveClass = 'table-responsive';
        if (typeof responsive === 'string') {
            responsiveClass = `${responsiveClass}-${responsive}`;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
Table.displayName = 'Table';
export { Table };
